import React from 'react'
import LicenseInfo from '../controls/LicenseInfo';

const LicensePane = (props) => {  
    
    return (
        <div>
            <LicenseInfo/>
        </div>
    );   
}
  
export default LicensePane;